import { LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { H6 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITileSection from 'UIComponents/tile/UITileSection';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAppPersonalizationTitleWrapper = styled(UITileSection).withConfig({
  displayName: "AppPersonalizationTitle__StyledAppPersonalizationTitleWrapper",
  componentId: "sc-11vgyvq-0"
})(["display:flex;"]);
export const AppPersonalizationTitle = () => {
  return /*#__PURE__*/_jsxs(StyledAppPersonalizationTitleWrapper, {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "p-right-2",
      style: {
        margin: 'auto 0',
        paddingTop: '2px'
      } // it just needed the smallest adjustment
      ,
      color: LORAX,
      name: "highlyEngagedLead",
      size: "xs"
    }), /*#__PURE__*/_jsx(H6, {
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.overview.sidebar.appPersonalization.title"
        })
      })
    })]
  });
};